import { Button, Dropdown } from '@innovamat/glimmer-components';
import { useTranslation } from 'react-i18next';

import { useAddActionDropdown } from '../../hooks/use-add-action-dropdown';
import { useOrganization } from '../../hooks/use-organization';

type Props = {
  isDisabled?: boolean;
  isJourneys: boolean;
  handleAdd: () => void;
  showAddDemoStudent: boolean;
  onAddDemoStudent: () => void;
};

function ClassroomStudentsAddDropdown({
  isDisabled = false,
  isJourneys = false,
  handleAdd,
  showAddDemoStudent,
  onAddDemoStudent,
}: Props): JSX.Element | null {
  const { t } = useTranslation();
  const { isRosteringEnabled } = useOrganization();

  const { getOptions } = useAddActionDropdown({
    type: 'student',
    onAddDefault: handleAdd,
    onAddDemoStudent: showAddDemoStudent ? onAddDemoStudent : undefined,
  });

  if (isJourneys) {
    return (
      <Button rightIcon="AddUpIcon" variant="secondary" onClick={handleAdd}>
        {t('students.button.addStudent')}
      </Button>
    );
  }

  if (isRosteringEnabled) {
    return null;
  }

  return (
    <Dropdown openOnHover={!isDisabled} disabled={isDisabled}>
      <Dropdown.Toggle>
        <Button disabled={isDisabled} rightIcon="AddUpIcon" variant="secondary">
          {t('students.button.addStudent')}
        </Button>
      </Dropdown.Toggle>
      <Dropdown.Content position={'bottomRight'}>
        {getOptions().map((option) => (
          <Dropdown.Item {...option} />
        ))}
      </Dropdown.Content>
    </Dropdown>
  );
}

export { ClassroomStudentsAddDropdown };
